module.exports = __webpack_public_path__ + "static/media/solution-4-sec2.0b3d1182.png";